import { DeviceLocationEnum } from '@modules/digital-signage/model/devices.model.ts';
import { ApiResponse } from '@shared/models/api.model';
import axiosInstance from '../axios-instance';
import {
  DeviceCodeDataProps,
  DevicesModel
} from '@modules/room-devices/model/devices.model.ts';
import { DeviceGroupDeviceModel } from '@shared/models/digital-signage/device-groups.model';

export const activateDeviceWithCode = async (
  body?: any
): Promise<DeviceCodeDataProps> => {
  return await axiosInstance.post(`/pms/devices/activateForSignage`, body);
};

export const getSignageDevices = async (
  params?: any
): Promise<ApiResponse<DevicesModel>> => {
  const response = await axiosInstance.get('/signage/devices/getter', {
    params
  });
  return response.data;
};

export const getSignageDevicesList = async (): Promise<
  DeviceGroupDeviceModel[]
> => {
  const response = await axiosInstance.get('/signage/devices');
  return response.data;
};

export const reloadDevices = async (body: {
  ids: string[];
  deviceLocation?: DeviceLocationEnum;
}): Promise<any> => {
  return await axiosInstance.put(`/pms/devices/reload`, body);
};

export const deleteDigitalSignageDeviceOrDevices = async (data: {
  ids: string[];
  deviceLocation: string;
}): Promise<void> => {
  return await axiosInstance.delete('/pms/devices', {
    data
  });
};
